import { useInstantSearch } from 'react-instantsearch'
import { Heading, Card, Skeleton, Stack, Grid } from '@backyard-ui/core'

import { IS_CATEGORY } from 'scripts/react-components/entry-key/utils/constants'
import { Markdown, ShowMore } from 'scripts/react-components/shared/components'

import * as S from './styled'
import { ContentList } from './ContentList'
import { ContentTagSEO } from '../../page'

interface TopContentProps {
  topDescription?: string
  categoryTitle?: string | null
  contents?: ContentTagSEO[]
}

const TopContent = ({
  contents,
  topDescription,
  categoryTitle
}: TopContentProps) => {
  const { indexUiState } = useInstantSearch()

  const query = indexUiState?.query || ''
  const topContentTitle = query.trim() === '' ? 'Produtos Recomendados' : query

  const title = () => {
    if (IS_CATEGORY) {
      return categoryTitle?.length ? (
        categoryTitle
      ) : (
        <Skeleton width="200px" height="29px" />
      )
    }

    return topContentTitle
  }

  return (
    <Card.Root>
      <Card.Body>
        <Heading>
          <div className="capitalize">{title()}</div>
        </Heading>
        {topDescription && (
          <ShowMore scrollToParent showFloatButton>
            <Markdown content={topDescription} type="medium" />

            {!!contents?.length && (
              <Stack spacing={5} direction="column">
                <Heading size="xl" asChild>
                  <h3>Veja também essas dicas Leroy Merlin</h3>
                </Heading>

                <Grid.Root>
                  <Grid.Item size="12">
                    <S.ContentWrapper>
                      <ContentList contents={contents} />
                    </S.ContentWrapper>
                  </Grid.Item>
                </Grid.Root>
              </Stack>
            )}
          </ShowMore>
        )}
      </Card.Body>
    </Card.Root>
  )
}

export default TopContent
